<script lang="ts">
    import { fade } from "svelte/transition";

    interface Props {
        showData: boolean;
    }

    let { showData = $bindable(false) }: Props = $props();
</script>

<div
    out:fade
    onoutroend={() => (showData = true)}
    class="h-full w-full flex flex-col items-center justify-center px-8 py-4"
>
    <div id="preloader" class="pb-4">
        <div id="loader"></div>
    </div>
</div>

<style>
    #loader {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        border: 3px solid transparent;
        --tw-border-opacity: 1;
        border-top-color: rgb(44 58 73 / var(--tw-border-opacity, 1));
        animation: spin 2s linear infinite;
    }
    #loader:before {
        content: "";
        position: absolute;
        top: 5px;
        left: 5px;
        right: 5px;
        bottom: 5px;
        border-radius: 50%;
        border: 3px solid transparent;
        --tw-border-opacity: 1;
        border-top-color: rgb(23 137 192 / var(--tw-border-opacity, 1));
        animation: spin 3s linear infinite;
    }
    #loader:after {
        content: "";
        position: absolute;
        top: 15px;
        left: 15px;
        right: 15px;
        bottom: 15px;
        border-radius: 50%;
        border: 3px solid transparent;
        --tw-border-opacity: 1;
        border-top-color: rgb(45 218 255 / var(--tw-border-opacity, 1));
        animation: spin 1.5s linear infinite;
    }
    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    @keyframes pulse {
        0% {
            transform: translatey(0px);
        }

        50% {
            transform: translatey(-5px);
        }
    }
</style>
